<template>
  <div>

    <div v-if="loading">Loading...</div>
    <div v-else>
      <router-link to="/demo">  
      <input type="text" class="search-bar" v-model="searchTerm" placeholder="Search by address or name..." />
        </router-link>
      <div v-if="anysubmissionsFound">
        <div class="result-list-container">

          <div class="result-list-box">
            <div class="result-list-title">
              <h3>Contracts</h3>
            </div>
            <div v-for="submission in filteredsubmissions" :key="submission.title" class="result-item">

              <router-link
                :to="{ name: 'TokenInfo', params: { tokenName: (submission.Token && submission.Token.name ? submission.Token.name.toString() : 'NA') }, query: { submission: JSON.stringify(submission) } }">
                <div class="result-info" @click="showSymbolPopup(submission)">
                  <p class="result-name"> {{ submission.Token && submission.Token.name ? submission.Token.name : 'NA' }}</p>

                  <p class="result-address">{{ submission.Token && submission.Token.address ? formatAddress(submission.Token.address) : 'NA'
                  }}</p>
                </div>
              </router-link>


            </div>
          </div>
          <div v-if="showPopup">

          </div>
          <div class="result-list-box">
            <div class="result-list-title">
              <h3>Binaries</h3>
            </div>
            <div v-for="submission in filteredsubmissionsTwo" :key="submission.title" class="result-item">
              <div class="result-info" @click="showSymbolPopup(submission)">
                
              </div>
            </div>
          </div>

          <div class="result-list-box">
            <div class="result-list-title">
              <h3>Submissions</h3>
            </div>
            <div v-for="submission in filteredsubmissionsThree" :key="submission.title" class="result-item">

              <router-link :to="{ name: 'DocumentInfo', params: { DocumentName: submission.DocumentName }, query: { id: submission._id } }">
                <div class="result-info" @click="showSymbolPopup(submission)">
                  <p class="result-name"> {{ submission.DocumentName ? submission.DocumentName : 'NA' }}</p>


                </div>
              </router-link>


            </div>
          </div>

        </div>
      </div>
      <div v-else-if="searchTerm.length > 0">
        No results found.
      </div>
    </div>
    <div v-if="showPopup" class="popup">
      <div class="popup-content">

        <TokenPopup :selectedSubmission="selectedSubmission" />
        <router-view :selectedSubmission="selectedSubmission"></router-view>

      </div>
    </div>
  </div>
</template>

<script>
import { ApolloClient, InMemoryCache, gql } from '@apollo/client/core';
import TokenPopup from './TokenPopup.vue';

export default {

  props: {

    tokenName: String,
    chainID: String,
    symbol: String,
    // Add other properties as needed
  },

  components: {
    TokenPopup
  },



  data() {
    return {
      loading: true,
      submissions: [],
      searchTerm: '',
      showPopup: false,
      selectedSubmission: null,
    };
  },
  async created() {
    try {
      const client = new ApolloClient({
        uri: 'https://glossi.fi/graphql',
        headers: {
          
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ik1pdGNoIiwidXNlcm5hbWUiOiJtaXRjaGVsbF93byIsInJvbGVzIjpbImFkbWluIl0sImlhdCI6MTY5MzQyMTk2MH0.75IQ1_HEkGdpGboxb8nMLFZdahVBxag-OmfXnIkwgZ8',
          // Add other custom headers here if needed
        },
        cache: new InMemoryCache(),
      });

      const query = gql`
        query {

          submissions {
            _id
            binaryId

            subjectAddress
            submissionType

            tags
            version
            DocumentName
            SigningAddress
            Timestamp
            bugReportId
            commentSubmissions
            generalSubmission
            addresses


            functions{
            names
            }

            Token {
  
  chainID
  symbol
  name
  address
  basesubmission {
    tags
  }
  logoURI
  extensions {
    l2GatewayAddress
    l1GatewayAddress
    l1Address
    bridgeInfo {
      tokenAddress
      originBridgeAddress
      destBridgeAddress
    }
  }
  decimal
  SigningAddress
  DocumentName
}
            }
        }
      `;

      const response = await client.query({ query });
      this.submissions = response.data.submissions;
      this.loading = false;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
  computed: {

    anysubmissionsFound() {
    return this.filteredsubmissions.length > 0 || this.filteredsubmissionsTwo.length > 0 || this.filteredsubmissionsThree.length > 0;
  },

    filteredsubmissions() {
      if (!this.searchTerm) {
        return [];
      }

      const searchTermLower = this.searchTerm.toLowerCase();
      return this.submissions.filter(
        (submission) =>
          (submission.Token && submission.Token.name && submission.Token.name.toLowerCase().includes(searchTermLower))
          ||
          (submission.Token && submission.Token.address && submission.Token.address.toLowerCase().includes(searchTermLower))

      );
    },
    filteredsubmissionsTwo() {
      if (!this.searchTerm) {
        return [];
      }

      const searchTermLower = this.searchTerm.toLowerCase();
      return this.submissions.filter(
        (submission) =>

          (submission && submission.binaryId && submission.binaryId.toLowerCase().includes(searchTermLower))

      );
    },

    filteredsubmissionsThree() {
      if (!this.searchTerm) {
        return [];
      }

      const searchTermLower = this.searchTerm.toLowerCase();
      return this.submissions.filter(
        (submission) =>

          (submission && submission.DocumentName && submission.DocumentName.toLowerCase().includes(searchTermLower))
      );
    },

  },
  methods: {
    showSymbolPopup(submission) {
      this.selectedSubmission = submission;

    },
    closePopup() {
      this.showPopup = false;
      this.selectedSubmission = null;
    },

    formatAddress(address) {
      if (address.length > 10) {
        return address.substring(0, 10) + '...' + address.slice(-5);
      }
      return address;
    },

  },
};
</script>

<style scoped>
.result-info,
.result-info p {
  text-decoration: none;
  /* Removes underline */
  color: black;
  /* Sets text color to black */
  cursor: pointer;
  /* Changes cursor to pointer to indicate it's clickable */
}

.router-link-active,
.router-link-exact-active,
.router-link-active .result-info,
.router-link-exact-active .result-info {
  text-decoration: none;
  color: black;
}

.search-bar {

  margin-top: 15px;
}

.result-list-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 70px;

}

.result-list-box {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  padding: 0px;
  width: 30%;

  justify-content: left;
  border-radius: 1%;
  height: 525px;
  overflow-y: auto;
}

.result-item {
  margin-bottom: 10px;
}

.result-info {
  cursor: pointer;
}

.result-name {
  font-weight: bold;
  color: #777;
}

.result-address {
  margin-top: 5px;
  color: #777;
}





input:hover {

  background-color: #c2baba;



}

input {
  width: 40%;
  /* adjust width as desired */
  height: 40px;
  /* adjust height as desired */
  padding: 0 20px;
  /* add padding as desired */
  border: none;
  /* remove border if desired */
  border-radius: 5px;
  /* add border radius to make it rounded */
  font-size: 20px;
  /* adjust font size as desired */
  font-family: 'Courier New', Courier, monospace;
}</style>
